<pp-common-confirm-dialog-content
  [title]="null"
  [subTitle]="description | translate"
  [cancelCaption]="'shell.header.salesToggle.actions.cancel' | translate"
  [okCaption]="confirmation | translate"
  iconName="agent-accounts"
  [status]="status"
  (discard)="closeDialog()"
  (ok)="confirm()" />
